<div class="academic-post92-report">
  <PageControl :title="'Academic Post 92 Check Report'" :elements_query="sheet_elements">
    <button
      @click="show_export_modal"
      class="btn btn-bg-green text-xs rounded-small shadow-sm me-2"
    >
      <i class="bi bi-download"></i>
      Export Data
    </button>

    <Teleport to="body">
      <div
        class="modal fade"
        :id="'export-modal-' + report_reference"
        tabindex="-1"
        aria-hidden="true"
        :aria-labelledby="'export-modal-label-' + report_reference"
      >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-4 shadow">
          <div class="modal-header">
            <h6 class="modal-title fw-semibold text-muted" :id="'export-modal-label-' + report_reference">
              Export Academic Post 92 Check Report Data
            </h6>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label fw-bold">Select Data to Export:</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.verification_data"
                  :id="'verification-data-' + report_reference"
                />
                <label class="form-check-label" :for="'verification-data-' + report_reference">
                  Verification Data
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.response_data"
                  :id="'response-data-' + report_reference"
                />
                <label class="form-check-label" :for="'response-data-' + report_reference">
                  Response Data
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.subjects"
                  :id="'subjects-data-' + report_reference"
                />
                <label class="form-check-label" :for="'subjects-data-' + report_reference">
                  Subjects
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.raw_json"
                  :id="'raw-json-' + report_reference"
                />
                <label class="form-check-label" :for="'raw-json-' + report_reference">
                  Raw JSON
                </label>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label fw-bold">Export Format:</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="csv"
                  v-model="export_format"
                  :id="'export-format-csv-' + report_reference"
                />
                <label class="form-check-label" :for="'export-format-csv-' + report_reference">
                  CSV (separate files per table)
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="excel"
                  v-model="export_format"
                  :id="'export-format-excel-' + report_reference"
                />
                <label class="form-check-label" :for="'export-format-excel-' + report_reference">
                  Excel (multiple sheets)
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="json"
                  v-model="export_format"
                  :id="'export-format-json-' + report_reference"
                />
                <label class="form-check-label" :for="'export-format-json-' + report_reference">
                  JSON
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-2"
              @click="close_modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-bg-green text-xs rounded-small shadow-sm"
              @click="export_data"
              :disabled="!has_selected_tables"
            >
              <i class="bi bi-download me-1"></i>
              Export Data
            </button>
          </div>
        </div>
      </div>
    </div>
    </Teleport>
  </PageControl>

  <PageComponent>
    <SectionSheet>
      <div class="container-fluid py-3 header d-flex align-items-center justify-content-between border-bottom mb-3">
        <div class="d-flex">
          <img
            class="logo"
            width="295"
            height="125"
            src="@/assets/images/new_black_logo2.svg"
            alt="Logo"
          />
        </div>
        <div class="d-flex text-end">
          <div>
            <div class="h4 fw-bold mb-1">Matric Qualification Check</div>
            <div class="text-muted text-xs">
              28 Fricker Rd,<br />
              Illovo, Johannesburg,<br />
              2196 South Africa<br />
              Website:
              <a
                href="https://www.goodpeopledata.com/"
                target="_blank"
                class="text-decoration-none text-muted"
              >
                www.goodpeopledata.com
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm border bg-white mb-2">
        <div class="card-header">
          <h6 class="mb-0">Verification Summary</h6>
        </div>
        <div class="card-body">
          <div class="row g-3 mb-3">
            <div class="col-md-3">
              <div class="status-card-simple" :class="result_state_class">
                <div
                  class="status-icon-simple"
                  :class="{
                    success: is_positive_result,
                    danger: is_negative_result,
                    warning: is_unconfirmed_result,
                    secondary: !is_positive_result && !is_negative_result && !is_unconfirmed_result
                  }"
                >
                  <i class="bi bi-shield-check"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Verification Status</div>
                  <div class="status-value-simple" :class="result_status_class">
                    {{ verification_status_display }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="status-card-simple" :class="result_state_class">
                <div
                  class="status-icon-simple"
                  :class="{
                    success: is_positive_result,
                    danger: is_negative_result,
                    warning: is_unconfirmed_result,
                    secondary: !is_positive_result && !is_negative_result && !is_unconfirmed_result
                  }"
                >
                  <i class="bi bi-check-circle"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Result</div>
                  <div class="status-value-simple" :class="result_status_class">
                    {{ result_display }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-calendar-date"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Year</div>
                  <div class="status-value-simple">{{ year }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-mortarboard"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Qualification</div>
                  <div class="status-value-simple">{{ qualification_description }}</div>
                </div>
              </div>
            </div>
          </div>

          <p>
            This report documents the Academic Post 92 Check conducted for
            <span class="fw-bold text-dark">{{ full_name }}</span>
            with ID Number <span class="fw-bold text-dark">{{ id_number }}</span>.
          </p>
          <p>
            The verification was performed for academic credentials from the year
            <span class="fw-bold text-dark">{{ year }}</span>,
            for the qualification: <span class="fw-bold text-dark">{{ qualification_description }}</span>.
          </p>

          <div class="status-description mt-3" :class="result_status_class">
            {{ result_summary_text }}
          </div>
          <div v-if="is_unconfirmed_result && status_reason_text" class="status-reason mt-2">
            {{ status_reason_text }}
          </div>
        </div>
      </div>

      <div class="card shadow-sm border bg-white mb-2">
        <div class="card-header">
          <h6 class="mb-0">Personal Information</h6>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-person"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Names</div>
                  <div class="status-value-simple">{{ names }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-person-badge"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Surname</div>
                  <div class="status-value-simple">{{ surname }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="maiden_name && maiden_name !== 'N/A'">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-person-heart"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Maiden Name</div>
                  <div class="status-value-simple">{{ maiden_name }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-hash"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">ID Number</div>
                  <div class="status-value-simple">{{ id_number }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-calendar-date"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Date of Birth</div>
                  <div class="status-value-simple">{{ formatted_date_of_birth }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="report-meta">
        <div><span class="text-muted">Ref:</span> {{ report_reference }}</div>
        <div><span class="text-muted">Generated:</span> {{ generated_date }}</div>
      </div>
    </SectionSheet>

    <SectionSheet>
      <div ref="academicCard" class="card shadow-sm border bg-white mb-2">
        <div class="card-header">
          <h6 class="mb-0">Academic Credentials</h6>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-calendar-event"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Year</div>
                  <div class="status-value-simple">{{ year }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-award"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Qualification Code</div>
                  <div class="status-value-simple">{{ qualification }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-mortarboard"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Qualification Type</div>
                  <div class="status-value-simple">{{ qualification_description }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-file-earmark-text"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Document Number</div>
                  <div class="status-value-simple">{{ document_number }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-file-text"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Document Type</div>
                  <div class="status-value-simple">{{ document_type }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-calculator"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Aggregate</div>
                  <div class="status-value-simple">{{ aggregate }}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple secondary">
                  <i class="bi bi-book"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Number of Subjects</div>
                  <div class="status-value-simple">{{ number_of_subjects }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-4" v-if="has_subjects">
            <h6 class="mb-3">
              <i class="bi bi-journal-text me-2"></i>
              Subjects
            </h6>
            <div class="table-responsive">
              <table class="table-modern">
                <thead>
                  <tr>
                    <th style="width: 60px;">#</th>
                    <th>Subject Name</th>
                    <th style="width: 150px;">Subject Code</th>
                    <th style="width: 120px;">Mark</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(subject, index) in subjects" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>
                      <i class="bi bi-journal-text me-2 text-muted"></i>
                      {{ subject.name || 'N/A' }}
                    </td>
                    <td>{{ subject.code || 'N/A' }}</td>
                    <td>
                      <span class="badge" :class="getMarkBadgeClass(subject.mark)">
                        {{ subject.mark || 'N/A' }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="alert alert-info mt-3" v-else>
            <i class="bi bi-info-circle me-2"></i>
            No subjects information available for this verification.
          </div>
        </div>
      </div>

      <div
        ref="reasonsSection"
        class="card shadow-sm border bg-white mb-2"
        v-if="has_reasons"
      >
        <div class="card-header">
          <h6 class="mb-0">Verification Reasons</h6>
        </div>
        <div class="card-body">
          <ul class="mb-0">
            <li v-for="(reason, index) in reasons" :key="index">{{ reason }}</li>
          </ul>
        </div>
      </div>

      <div ref="disclaimerCard" class="card shadow-sm border bg-white mb-4 p-2">
        <div class="card-header">
          <h6 class="mb-0">Disclaimer & Important Information</h6>
        </div>
        <div class="card-body">
          <p class="text-xs mb-2">
            <strong>External Data Source:</strong>
            This Academic Post 92 Check Report contains unmodified data and has not been altered in any way for this report by
            <a href="https://www.goodpeopledata.com/" target="_blank" rel="noopener"><strong>THE GOOD PEOPLE DATA COMPANY (PTY) LTD.</strong></a>
          </p>
          <p class="text-xs mb-2">
            <strong>Data Source:</strong>
            The verification is performed against the Department of Basic Education's National Learner Records Database (NLRD)
            for academic qualifications obtained post-1992 in South Africa. The verification results depend on the quality and completeness of the data available in the database at the time of verification.
          </p>
          <p class="text-xs mb-2">
            <strong>Verification Scope:</strong>
            This check verifies the authenticity of academic credentials for post-1992 qualifications, including National Senior Certificate (NSC), Further Education and Training Certificate (FETC), and other related qualifications.
          </p>
          <p class="text-xs mb-0">
            <strong>Data Privacy:</strong>
            All personal and academic information in this report is treated as confidential and should be handled in accordance with applicable data protection regulations.
          </p>
        </div>
        <div class="provider-box my-3 text-center">
          Academic Post 92 Check report was generated by
          <a href="https://www.goodpeopledata.com/" target="_blank" rel="noopener"><strong>THE GOOD PEOPLE DATA COMPANY (PTY) LTD.</strong></a>
        </div>
      </div>

      <div class="report-meta">
        <div><span class="text-muted">Ref:</span> {{ report_reference }}</div>
        <div><span class="text-muted">Generated:</span> {{ generated_date }}</div>
      </div>
    </SectionSheet>
  </PageComponent>
</div>
